// extracted by mini-css-extract-plugin
export var content = "_pi-1";
export var fullScreen = "_pi-0";